import { useProviderEnrollments } from '@/hooks/use-enrollments';
import { useTerms } from '@/hooks/use-terms';
import { Ionicons } from '@expo/vector-icons';
import React from 'react';
import { Platform, Pressable, View } from 'react-native';
import { EnrollmentCard } from '../services/enrollment-card';
import { ThemedText } from '../themed-text';
import { Button } from '../ui/button';
import { Card } from '../ui/card';
import { SkeletonListRow } from '../ui/skeleton';
import { ErrorState } from '../ui/error-state';
import { EmptyState } from '../ui/empty-state';
import { FadeInView } from '../ui/fade-in-view';
import { router } from 'expo-router';

export function EnrollmentsCard() {
  const {
    data: paginatedData,
    isLoading,
    error,
    refetch,
  } = useProviderEnrollments({
    page: 1,
    limit: 5, // Limitar a 5 itens para preview na home
  });

  const enrollments = paginatedData?.data || [];
  const terms = useTerms();

  const handleNewEnrollment = () => {
    router.navigate('/(tabs)/(provider)/enrollments/new');
  };

  const isMobile = Platform.OS !== 'web';

  return (
    <Card className="w-full gap-4 p-4">
      <View className="flex-row items-center justify-between">
        <ThemedText className="font-semibold text-base text-card-foreground">
          {terms.title.enrollmentPlural}
        </ThemedText>
        <Button
          onPress={handleNewEnrollment}
          title={
            isMobile
              ? `+ ${terms.title.enrollment}`
              : `+ ${terms.agree('Novo', 'enrollment')} ${terms.enrollment}`
          }
          size="xs"
          className="shrink-0"
        />
      </View>
      <View>
        {isLoading ? (
          <View>
            {Array.from({ length: 2 }).map((_, index) => (
              <SkeletonListRow key={index} />
            ))}
          </View>
        ) : error ? (
          <ErrorState
            variant="inline"
            title={`Erro ao carregar ${terms.enrollmentPlural}`}
            message={
              error
                ? `Não foi possível carregar ${terms.agree('os', 'enrollment')} ${terms.enrollmentPlural}.`
                : 'Dados indisponíveis.'
            }
            onRetry={refetch}
          />
        ) : enrollments.length ? (
          <>
            {enrollments.slice(0, 5).map((enrollment, index) => (
              <FadeInView key={enrollment.id} delay={index * 50}>
                <EnrollmentCard enrollment={enrollment} size="small" />
              </FadeInView>
            ))}
            <Pressable
              onPress={() => router.push('/(tabs)/(provider)/enrollments')}
              accessibilityRole="button"
              className="mt-1 flex-row items-center justify-between rounded-xl px-1 py-2.5 active:opacity-70"
            >
              <ThemedText className="text-sm font-semibold text-primary">
                {`Ver ${terms.agree('todos', 'enrollment')} ${terms.agree('os', 'enrollment')} ${terms.enrollmentPlural}`}
              </ThemedText>
              <Ionicons name="arrow-forward" size={16} color="#FD5001" />
            </Pressable>
          </>
        ) : (
          <EmptyState
            icon="document-text-outline"
            title={`${terms.agree('Nenhum', 'enrollment')} ${terms.enrollment} ${terms.agree('ativo', 'enrollment')}`}
            description={`${terms.agree('Seus', 'enrollment')} ${terms.enrollmentPlural} ${terms.agree('ativos', 'enrollment')} aparecerão aqui.`}
            className="py-6"
          />
        )}
      </View>
    </Card>
  );
}
